import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 320 308"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "5",
      d: "M161.5 5.4h5.9c45.6 0 82.4 14.4 108 40.3 25.4 25.8 39.7 63.2 39.7 109.2 0 46.2-14 83-39.2 108.4s-61.8 39.3-107.4 39.3h-13c-46.6 0-84.3-13.9-110.1-39.3C19.5 237.9 5 201.1 5 155c0-46.2 14.4-83.4 40.4-109.2S109 5.5 155.5 5.5z",
      class: "o-outline"
    }, null, -1)
  ]))]))
}
export default { render: render }